import React, { useContext, useEffect } from "react";
import ContactForm from "./ContactForm";
import { MenuContext } from "../../App";

function Contact() {
  const [isMenuClicked, setIsMenuClicked] = useContext(MenuContext);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setIsMenuClicked(!isMenuClicked);
  }, []);
  
  return (
    <div className="w-full md:py-5 flex flex-col items-center">
      <div className="w-full py-10 flex flex-col items-center">
        <div className="text-4xl md:text-7xl">Contact Us</div>
        <div className="flex pt-5 gap-x-10 px-5">
          <a href="mailto:anitsolutions0707@gmail.com">
            <img
              src="icons/Gmail.png"
              alt=""
              width={150}
              height={150}
              className="hover:scale-105 duration-200"
            />
          </a>
          <a href="https://wa.me/+919415814600" target="blank">
            <img
              src="icons/WhatsApp.png"
              alt=""
              width={150}
              height={150}
              className="hover:scale-105 duration-200"
            />
          </a>
          <a
            href="https://www.linkedin.com/messaging/compose?sendMessage=true&recipientId=[USER_ID]"
            target="blank"
          >
            <img
              src="icons/LinkedIn.png"
              alt=""
              width={150}
              height={150}
              className="hover:scale-105 duration-200"
            />
          </a>
          <a href="http://m.me/An-it solution company" target="blank">
            <img
              src="icons/Facebook.png"
              alt=""
              width={150}
              height={150}
              className="hover:scale-105 duration-200"
            />
          </a>
          <a href="https://www.instagram.com/itssolutioncompany/" target="blank">
            <img
              src="icons/Instagram.png"
              alt=""
              width={150}
              height={150}
              className="hover:scale-105 duration-200"
            />
          </a>
        </div>
      </div>

      <div className="w-4/5 mt-10 p-10 gap-y-5 flex flex-col items-center justify-center bg-black bg-opacity-20 rounded-lg">
        <h3 className="text-2xl md:text-5xl">We'd like to continue the conversation!</h3>
        <p className="text-base md:text-xl pt-5 tracking-wide">
          Engaging with us is simple! Whether we meet in person, by phone or web
          conference, we want to learn more about the things that matter most to
          you and what you want to accomplish. Together, we'll come up with the
          best way to move your business forward, faster.
        </p>
        <h3 className="text-lg md:text-xl tracking-wide">
          <span className="text-xl md:text-2xl font-semibold">Call</span> or{" "}
          <span className="text-xl md:text-2xl font-semibold">Email Us</span> and one of
          our specialists will get back to you quickly.
        </h3>
      </div>
      <div className="w-11/12 py-10 flex">
        <div className="w-1/2 text-wrap gap-y-5 py-10 px-2 md:px-5 flex flex-col items-start text-base md:text-xl bg-cyan-600">
          <div className="w-full flex justify-center">
            <h3 className="text-xl md:text-3xl text-center font-semibold">
              An IT Solution Company <br /> Headquarters
            </h3>
          </div>
          <p>
            <span className="font-medium">Address:</span> <br />
            J-970, 11th Ave, <br />
            Sector 16c, Greater Noida
          </p>
          <p>
            <span className="font-medium">Phone:</span> <br />
            (+91)- 7895927366
          </p>
          <p className="">
            <span className="font-medium">Email:</span> <br />
            anitsolutions0707@gmail.com
          </p>
        </div>
        <div className="w-1/2 flex justify-center items-center bg-[#4A57BF]">
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default Contact;
